module.exports = __webpack_public_path__ + "assets/img/package_script.0c3041c9.jpg";